<div class="pb-4 border-b border-gray-200">
	<ui-content-header
		title="Connect to Sync By Closer"
		type="section"
	></ui-content-header>
</div>
<section class="flex flex-col gap-4 py-4">
	<!-- <ng-container *ngIf="!user?.closerSyncId; else requiresSignature"> -->
	<ng-container>
		<div class="flex gap-4 mb-4">
			<div class="w-48 h-48 p-8">
				<img
					src="assets/images/integrations/sync-logo.png"
					alt="Sync by Closer Logo"
				/>
			</div>
			<div class="flex flex-col gap-4">
				<h3 class="h3">Welcome to Sync, let’s get things going!</h3>
				<p class="p-lg">
					To integrate with Sync, four items need to be completed by
					{{ user.firstName }} {{ user.lastName }}:
				</p>
				<closer-sync-auth-required-list
					possessiveAdjective="their"
				></closer-sync-auth-required-list>
			</div>
		</div>
		<div class="flex flex-col gap-2 bg-tealGreen-50 rounded-lg p-6">
			<h3 class="h3">Want to get things started?</h3>
			<p class="p-sm">Send a request to integrate with Sync by Closer.</p>
		</div>
	</ng-container>

	<!-- <ng-template #requiresSignature>
        <h3 class="h3">Signature Required</h3>
        <p class="p-sm">This lawyer does not have a signature on file. Please have them add this themself to complete
            connecting to Sync by Closer.</p>
        <ui-note title="What's this used for?">
            <p class="p-sm">
                The lawyer's signature will only be used during mortgage processing to complete:
            </p>
            <ul class="list-inside">
                <li class="p-sm">Request for Fund</li>
                <li class="p-sm">Final Reports</li>
            </ul>
        </ui-note>
        <ui-note title="This is only used for Sync by Closer." type="warning">
        </ui-note>
    </ng-template> -->
</section>
<footer
	class="w-full flex justify-end pt-6 gap-4 border-t border-gray-200 mt-4"
>
	<ui-button
		class="flex-1 max-w-52"
		fullWidth="true"
		label="Cancel"
		preset="EXTRA_LOW_EMPHASIS"
		(click)="close()"
	></ui-button>
	<ui-button
		class="flex-1 max-w-52"
		fullWidth="true"
		label="Send Invite"
		(click)="sendEmail()"
	></ui-button>
</footer>
